import React from 'react'
import UserContracts from 'pages/app/hr/UserContracts'
import { useValue } from '@morningtrain/react-resources'

export default function UserContractsView () {
  const userId = useValue('id')

  if (!userId) {
    return null
  }

  return (
    <UserContracts userId={userId} />
  )
}
